import React from 'react'
import { QueueHealth, QUEUE_HEALTH_COLORS } from '../types/operations.types'
import { StatusDot } from '../styled/Operations.styled'

interface QueueHealthBadgeProps {
  health: QueueHealth
}

export const QueueHealthBadge: React.FC<QueueHealthBadgeProps> = ({ health }) => {
  const color = QUEUE_HEALTH_COLORS[health]
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12px', fontWeight: 500, color }}>
      <StatusDot color={color} />
      {health}
    </span>
  )
}
